<template functional>
  <input
    class="form-control"
    :class="props.customClass"
    :value="props.value"
    :placeholder="props.placeholder"
    v-on="listeners"
    :name="props.name"
    :disabled="props.disabled"
    :readonly="props.readonly"
  />
</template>

<script>
export default {
  props: {
    value: { type: String, default: null },
    name: { type: String },
    customClass: { type: String, default: '' },
    placeholder: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
